<template>
    <div>
        <div class="head">
            <img class="imgs" :src="fourLogo" alt="" srcset="" />
            <h2 class="title">生猪大数据中心</h2>
            <div class="headBox">
                <div
                    class="headItem"
                    v-for="(item, index) in titleHead"
                    :key="index"
                    @click="selectHead(item, index)"
                >
                    <div>
                        {{ item.label }}
                    </div>
                    <div class="active" v-if="item.active"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let vm;
import fourLogo from "@/assets/imgs/fourIndexImg/fourLogo.png";
export default {
    name: "titleHead",
    data() {
        return {
            fourLogo: fourLogo,
            activeIndex: 0,
            titleHead: [
                {
                    label: "首页",
                    active: true,
                    path: "/fourIndex",
                },
                {
                    label: "今日猪价",
                    active: false,
                    path: "/dayPrice",
                },
                {
                    label: "每日猪讯",
                    active: false,
                    path: "/dayNews",
                },
                {
                    label: "产业指数",
                    active: false,
                    path: "/IndProd",
                },
                {
                    label: "核心数据",
                    active: false,
                    path: "/monitoringData",
                },
                {
                    label: "公示公告",
                    active: false,
                    path: "/noticeList",
                },
                {
                    label: "关于我们",
                    active: false,
                    path: "/aboutUs",
                },
            ],
        };
    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                vm.titleHead.forEach((el, index) => {
                    el.active = false;
                    if (el.path && newVal.path == el.path) {
                        el.active = true;
                        vm.activeIndex = index;
                    }
                });
            },
            deep: true,
        },
    },
    beforeCreate() {
        vm = this;
    },
    mounted() {
        vm.titleHead.forEach((el, index) => {
            el.active = false;
            if (el.path && vm.$route.path == el.path) {
                el.active = true;
                vm.activeIndex = index;
            }
        });
    },
    methods: {
        selectHead(item, index) {
            // if (index != vm.activeIndex) {
            //     vm.titleHead[index].active = true;
            //     vm.titleHead[vm.activeIndex].active = false;
            //     vm.activeIndex = index;
            // }
            if (item.path) {
                vm.$router.push({
                    path: item.path,
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.imgs {
    height: 44px;
    width: 44px;
}
.head {
    display: flex;
    height: 44px;
    align-items: center;
    margin-top: 42px;
    z-index: 100;
    position: relative;
}
.title {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 33px;
    margin-left: 12px;
    letter-spacing: 2px;
}
.headBox {
    display: flex;
    height: 44px;
    justify-content: space-around;
    letter-spacing: 2px;
    margin-left: 48px;
    align-items: center;
    .headItem {
        color: white;
        font-size: 16px;
        height: 100%;
        font-weight: 500;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #ffffff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 10px;
        cursor: pointer;
        .active {
            width: 100%;
            height: 2px;
            background: #ffffff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/titleHead/titleHead.vue